var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hungary",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.03,
    height: 32.03,
    viewBox: "0 0 32.03 32.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2053",
    "data-name": "Path 2053",
    d: "M1,146.089A16.073,16.073,0,0,0,1,157.23l15.019,1.393,15.019-1.393a16.073,16.073,0,0,0,0-11.141L16.015,144.7Z",
    transform: "translate(0 -135.644)",
    fill: "#f0f0f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    d: "M30.943,0A16.021,16.021,0,0,0,15.924,10.445H45.962A16.021,16.021,0,0,0,30.943,0Z",
    transform: "translate(-14.928)",
    fill: "#d80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    d: "M30.943,355.488a16.021,16.021,0,0,0,15.019-10.445H15.924A16.021,16.021,0,0,0,30.943,355.488Z",
    transform: "translate(-14.928 -323.457)",
    fill: "#6da544"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHu);
export default __webpack_public_path__ + "static/media/HU.2338016c843a213edfb457fee74da049.svg";
export { ForwardRef as ReactComponent };